//  font renamed as cardiuma-M - 23-08-24 - Dev Srini
const styles = theme => ({
    indicator: {
        backgroundColor: '#F3D45E ! important',
        width: '3px', // Srini - 12/11/24
        position: 'absolute',
        position: 'absolute',
        top: '0',
        right: '0',
        bottom: '0',
        borderRadius: '5px',
    },

    verticalTabLayout: {
        width: '100%',
        height: '100%',
        marginLeft: '3%',
        flexShrink: 0,
        background: '#241E41',
        boxShadow: '0px 0px 12px 0px rgba(0, 0, 0, 0.09)',
    },

    dashboardText: {
        color: 'var(--b, #FFF) ! important',
        fontFamily: 'cardiuma-M ! important',
        fontSize: '14px ! important',
        fontStyle: 'normal',
        fontWeight: '500 ! important',
        lineHeight: '20px ! important',
        width: '199px',
        height: '48px',
        flexShrink: 0,
        // background: '#000 ! important',
    },
  
})

export default styles
